import { defineStore } from "pinia";
import { supabase } from "src/boot/supabase";

interface UserData {
  first_name: string;
  last_name: string;
  approved: boolean;
  roles: string[];
}

interface UserRoleRow {
  role_id: string;
}

export function isProfileComplete(user: UserData): boolean {
  if (!user.first_name || !user.last_name) {
    return false;
  }
  return true;
}

export const useUserStore = defineStore("user", {
  state: () => ({
    isLoggedIn: false,
    isApproved: false,
    isAdmin: false,
    INACTIVITY_TIMEOUT: 300000, // 5 minut w milisekundach
    user: {
      first_name: "",
      last_name: "",
      approved: false,
      roles: [],
    } as UserData,
  }),
  getters: {
    getInactivityTimeout(state) {
      return state.INACTIVITY_TIMEOUT;
    },
  },
  actions: {
    resetStore() {
      this.isLoggedIn = false;
      this.isApproved = false;
      this.isAdmin = false;
      this.user = {
        first_name: "",
        last_name: "",
        approved: false,
        roles: [],
      };
    },
    setUser(data: UserData) {
      this.isLoggedIn = true;
      this.isApproved = data.approved;
      this.isAdmin = data.roles.includes("admin");
      this.user = { ...data };
    },
    async loadUserRoles(userId: string) {
      const { data, error } = await supabase
        .from("user_roles")
        .select("role_id")
        .eq("user_id", userId);

      if (error) {
        console.error("Error loading roles:", error);
        this.user.roles = [];
        this.isAdmin = false;
      } else {
        const roleIds = (data as UserRoleRow[])?.map((row) => row.role_id) ||
          [];
        this.user.roles = roleIds;
        this.isAdmin = roleIds.includes("2637d4ac-6b07-4078-9656-e5f3a0aaa0e4"); // ID roli admin
      }
    },
  },
});
